export default "__VITE_ASSET__6299af0a__"